import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";

import type { ConversationItemApi } from "@/Modules/Agent/Models/Api";
import type { ConversationItem } from "@/Modules/Agent/Models/Domain";

import { camel } from "@/Utils/Camelize";
import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

const ConversationTransformer: TransformerExtended<ConversationItem, ConversationItemApi> = {
  ...DefaultTransformerGenerator<ConversationItem, ConversationItemApi>(),

  toDomain(input: ConversationItemApi) {
    return camel<ConversationItemApi, ConversationItem>(input);
  },
};

export type ConversationTransformerType = TransformerExtended<ConversationItem, ConversationItemApi>;

export default ConversationTransformer;
